module.exports = __webpack_public_path__ + "img/procedural_growth_basic.38d2a32d.gif";